import { Injectable, signal } from '@angular/core';

/**
 * De supportchat (Crisp) zonder zijn eigen zwevende knop.
 *
 * De standaardknop van Crisp hangt rechtsonder over de pagina heen — over
 * de videospeler, de tag-zijbalk en op een telefoon over de tabbalk. Daarom
 * blijft de chatbox verborgen tot iemand op de knop in de koptekst
 * (rechtsboven) drukt; sluit hij de chat, dan verdwijnt de box weer. Het
 * chatvenster zelf opent nog steeds waar Crisp het zet, maar alleen als
 * daar bewust om is gevraagd.
 */
@Injectable({ providedIn: 'root' })
export class SupportChatService {
  /** Is de chat geladen én toegestaan op deze pagina (routes kunnen hem uitzetten)? */
  public readonly beschikbaar = signal(false);

  /** Na het laden van het Crisp-script: knop weg, en weer weg zodra de chat sluit. */
  public verbergStandaardKnop(): void {
    if (!window.$crisp) {
      return;
    }
    window.$crisp.push(['safe', true]);
    window.$crisp.push(['do', 'chat:hide']);
    window.$crisp.push(['on', 'chat:closed', () => window.$crisp.push(['do', 'chat:hide'])]);
  }

  public open(): void {
    if (!window.$crisp) {
      return;
    }
    window.$crisp.push(['do', 'chat:show']);
    window.$crisp.push(['do', 'chat:open']);
  }
}
